import { getBaseMetaTitle } from '@/environments'
import Main from './Main'

const route = {
  path: '/',
  name: 'home',
  meta: {
    title: `Home - ${getBaseMetaTitle}`
  },
  component: Main
}

export default route
